import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  DsBoxModule,
  DsButtonModule,
  DsIconModule,
  DsModalModule,
  DsProgressBarModule,
  DsTooltipDirectiveModule,
} from '@bmw-ds/components';

import { useI18n } from '../../../../i18n/services/i18n.service';

export interface Percentage {
  value: number;
  maxValue: number;
  icon: string;
}

@Component({
  selector: 'cdf-customer-insights-box',
  imports: [DsButtonModule, DsBoxModule, DsModalModule, DsIconModule, DsProgressBarModule, DsTooltipDirectiveModule],
  template: `
    <h3>
      {{ title() }}
      <ds-button
        class="information"
        icon="information"
        size="sm"
        variant="ghost"
        [ds-tooltip]="info()"
        [dsTooltipConfig]="{ origin: 'bottom', maxWidth: '25ch' }"
      />
    </h3>
    @if (percentage(); as percentage) {
      <div
        class="percentage-area"
        [ds-tooltip]="buildTooltipString(percentage)"
        [dsTooltipConfig]="{ origin: 'bottom' }"
      >
        <div class="progress-bar-container">
          <span>{{ i18n('customerInsights.low') }}</span>
          <ds-progress-bar
            variant="determinate"
            size="lg"
            [progress]="(percentage.value / percentage.maxValue) * 100"
          />
          <span>{{ i18n('customerInsights.high') }}</span>
        </div>

        <span class="progress-bar-label">
          <ds-icon [icon]="percentage.icon" size="sm" class="pt-1x" />
        </span>
      </div>
    }
    <div class="content"><ng-content /></div>
  `,
  styleUrl: './customer-insights-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerInsightsBoxComponent {
  readonly i18n = useI18n();

  readonly title = input.required<string>();
  readonly info = input.required<string>();
  readonly percentage = input<Percentage>();

  buildTooltipString(percentage: Percentage) {
    return percentage.value + ' / ' + percentage.maxValue;
  }
}
